import { useState, useMemo, useEffect } from "react";

// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import IMagnifier from "assets/i-magnifier.js";
import XIconSrc from "assets/cross.svg";

import { useGetCountryCodes } from "api/common/query";
import { useDebounce } from "hooks/useDebounce";

const ModalPilihCodeNegara = ({
  options,
  onClose,
  isOpen,
  selectedValue = null,
  onSelect,
  ...props
}) => {
  const [tempSelectedValue, setTempSelectedValue] = useState(selectedValue);

  const [search, setSearch] = useState("");

  const [countryCodeParams, setCountryCodeParams] = useState({
    q: "",
  });
  const { data: countryCodesData } = useGetCountryCodes({
    params: countryCodeParams,
  });

  const dataCountries = useMemo(() => {
    if (!countryCodesData?.data?.data?.length) return [];
    return countryCodesData.data.data;
  }, [countryCodesData]);

  const handleSelect = (country) => {
    setTempSelectedValue(country.dial_code);
  };

  const handleConfirm = () => {
    if (tempSelectedValue) {
      onSelect(tempSelectedValue);
      onClose();
    }
  };

  const { debounceFn } = useDebounce({
    onChange: (query) => {
      setCountryCodeParams({
        ...countryCodeParams,
        q: query,
      });
    },
    delay: 500,
  });

  const handleSearch = (e) => {
    setSearch(e.target.value);
    debounceFn(e.target.value);
  };

  useEffect(() => {
    if (selectedValue) {
      setTempSelectedValue(selectedValue);
    }
  }, [selectedValue]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[426px] z-[43] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between items-center px-4 py-3 border-b border-solid border-[#D8D8D9]">
          <p className="text-[16px] font-inter-semibold text-[#252526]">
            Pilih kode negara
          </p>
          <button
            onClick={onClose}
            className="w-6 h-6 flex items-center justify-center hover:bg-gray-100 rounded cursor-pointer"
          >
            <img src={XIconSrc} alt="Close" className="w-4 h-4" />
          </button>
        </div>

        <div className="flex flex-col items-center px-4 py-3">
          <div className="w-full h-[36px] px-3 py-2 flex items-center gap-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9]">
            <IMagnifier color="#252526" />
            <input
              className="h-full w-full text-[13px] leading-[20px] font-inter text-[#252526] placeholder:text-[#808285] outline-none"
              placeholder="Cari dengan nama negara"
              value={search}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="flex flex-col px-4 py-2 h-[400px] overflow-y-auto">
          {dataCountries.map((country) => (
            <div
              onClick={() => handleSelect(country)}
              key={country.code}
              className="flex items-center justify-between py-3 border-b border-solid border-[#E6E7E8] last:border-b-0 cursor-pointer hover:bg-gray-50"
            >
              <div className="flex items-center gap-3">
                <p
                  className={`text-[14px] text-[#252526] leading-[20px] ${
                    tempSelectedValue !== country.dial_code
                      ? "font-inter"
                      : "font-inter-semibold"
                  }`}
                >
                  {country.name}{" "}
                  <span className="text-[#808285] font-inter">
                    {country.dial_code}
                  </span>
                </p>
              </div>
              {tempSelectedValue !== country.dial_code ? (
                <div className="w-4 h-4 rounded-full bg-white border border-solid border-[#808285]"></div>
              ) : (
                <div className="flex items-center justify-center w-4 h-4 rounded-full bg-[#252526] border border-solid border-[#808285]">
                  <div className="w-2 h-2 rounded-full bg-white" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div
          className={
            "flex items-center justify-end gap-4 px-4 py-3 border-t border-solid border-[#D8D8D9]"
          }
        >
          <Button
            disabled={!tempSelectedValue}
            text="Gunakan"
            onClick={handleConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalPilihCodeNegara isOpen={isOpen} {...props} />;
};

export default Wrapper;
